import Vue from 'vue';
import VueRouter from 'vue-router';
import {home} from "@/router/modules/home";

Vue.use(VueRouter)

export const HOMEPAGE = 'Home';
export const WORK = 'Work';
export const RESUME = 'Resume';

const routes = [].concat(home);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  // Scroll to the top of the page upon route change.
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    return next({name: HOMEPAGE});
  }

  return next();
});
export default router
